<template>
    <div class="topBar">
        <b-container>
            <b-row align-v="center">
                <b-col cols="1">
                </b-col>
                <b-col cols="auto" class="mr-auto p-3">
                    <div>
                        <b-img src="https://promos.yelpcdn.com/food_delivery_icon_2x.png" height="36px" />
                        You can always order in
                    </div>
                </b-col>
                <b-col cols="auto" class="p-3">
                    <b-link class="mr-3">Delivery</b-link> 
                    <b-link class="mr-3">Pizza Delivery</b-link> 
                    <b-link class="mr-3">Chinese Food Delivery</b-link> 
                </b-col>
                <b-col cols="1">
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<style scoped>
.topBar {
    background-color: #f5f5f5;
    width: 100%;
}
</style>

<script>
export default {
    
}
</script>